import { OpenNewTabTargetType } from '@voltmoney/types';
import { ROUTE } from '../../routes';
import { ACTION } from './types';
import { isMobile, partnerNavigate } from '../../configs/utils';
import { sideBarNavigate } from "./utils";
const _isMobile = isMobile();
let date1 = '', date2 = '';
export const TestAction = async (action, _datastore, { navigate, goBack, setDatastore }) => {
    console.warn('**** Test Action Triggered ****', action);
    if (action.type === ACTION.VALIDATE_FORM_1) {
        date1 = action.payload.value;
    }
    if (action.type === ACTION.VALIDATE_FORM_2) {
        date2 = action.payload.value;
    }
};
export const onChangeTab = async (action, _datastore, standardUtilites) => {
    console.warn('INSIDE PLATFORM ON CHANGE TAB METHOD', action);
    await sideBarNavigate(standardUtilites, action);
};
export const RegisterClient = async (action, _datastore, { navigate, goBack, instrumentTrack }) => {
    instrumentTrack("ASSISTED_JOURNEY_BUTTON_CLICKED", {
        "page": "dashboard"
    });
    console.warn('**** RegisterClient Action Triggered ****', action);
    navigate(ROUTE.REGISTER_LEADS);
};
export const InviteClient = async (action, _datastore, { navigate, goBack, instrumentTrack }) => {
    instrumentTrack("INVITE_CLIENT_BUTTON CLICKED", {
        "page": "dashboard"
    });
    console.warn('**** InviteClient Action Triggered ****', action);
    const link = action.payload.link;
    navigate(ROUTE.INVITE_CLIENT, { _link: link });
};
export const goToMarketing = async (action, _datastore, utilities) => {
    console.warn('**** goToMarketing Action Triggered ****', action);
    await sideBarNavigate(utilities, action);
};
export const onLogoutPress = async (action, _datastore, { navigate, goBack, setDatastore }) => {
    console.warn('**** onLogoutPress Action Triggered ****', action);
    navigate(ROUTE.PLATFORM_LOG_OUT);
};
export const promoBannerInvite = async (action, _datastore, { openNewTab, instrumentTrack }) => {
    instrumentTrack("COLLATERAL_REQUEST_INITIATED", {
        "page": "dashboard"
    });
    console.warn('**** promoBannerInvite Action Triggered ****', action);
    openNewTab(`https://wa.me/919611749295?text=Kindly%20provide%20me%20with%20personalized%20co-branded%20marketing%20materials%20to%20help%20educate%20my%20clients.`, OpenNewTabTargetType.blank);
};
export const onKnowMore = async (action, _datastore, { instrumentTrack }) => {
    instrumentTrack("INVITE_PARTNER_BANNER_CTA_CLICKED", {
        "page": "dashboard"
    });
    console.warn('**** onKnowMore leads Action Triggered ****', action);
    await partnerNavigate(ROUTE.PARTNER_REFERRED_PARTNER);
};
export const openMenu = async (action, _datastore, { navigate }) => {
    console.warn('**** onKnowMore leads Action Triggered ****', action);
    await navigate(ROUTE.PARTNER_MENU, {
        isFromPlatform: true
    });
};
export const goToAccountDetails = async (action, _datastore, utilities) => {
    console.warn('**** goToAccountDetails leads Action Triggered ****', action);
    await sideBarNavigate(utilities, action);
};
